import DiscountCode from './DiscountCode.component';

export default DiscountCode;